import React, { useState } from "react";
import { faSearch, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Col,
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";

import PropTypes from "prop-types";
import { isZeroLengthString } from "../../../utils/normalize";
const PreferenceFilter = (props) => {
  const { onUserAction, loading } = props;
  const [accountNumber, setAccountNumber] = useState("");
  const [accountError, setAccountError] = useState(null);

  const onAccountNumberChange = (evt) => {
    setAccountNumber(evt.currentTarget.value);
    if (isZeroLengthString(evt.currentTarget.value)) {
      setAccountError(true);
    } else {
      setAccountError(false);
    }
  };

  const onSearchClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (isZeroLengthString(accountNumber)) {
      setAccountError(true);
      return false;
    }
    onUserAction(accountNumber);
  };

  return (
    <Card>
      <CardHeader>
        <Row className="mb-1">
          <Col>
            <h4 className="text-muted">Customer Preference Look Up</h4>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Row>
          <Col xs="auto" className="mt-n1">
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <FontAwesomeIcon icon={faSearch} />
                  Search Account Number:
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Account Number"
                name="accountNumber"
                value={accountNumber}
                onChange={onAccountNumberChange}
                size={40}
                maxLength={20}
              />
            </InputGroup>
            <span className="text-danger">{accountError && "Enter Account Number"}</span>
          </Col>
          <Col xs="auto" className="mt-n1">
            <Button color="primary" onClick={(e) => onSearchClick(e)} disabled={loading}>
              Preference Lookup
              {loading && <FontAwesomeIcon icon={faSpinner} className="ml-2" spin />}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

PreferenceFilter.propTypes = {
  mbIdFilter: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  onSearchClick: PropTypes.func.isRequired,
  onUserAction: PropTypes.func.isRequired,
  onClickUniqueIdFetch: PropTypes.func.isRequired,
};
export default PreferenceFilter;
